import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { Button } from 'reactstrap';
import { Download } from 'react-feather';

function PDFViewer({ isActive, url, token, isPdfDownload = false }) {
  const zoomPluginInstance = zoomPlugin();
  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
  const [pdfBlob, setPdfBlob] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isActive) {
      setIsLoading(true);
      const uninterceptedAxiosInstance = axios.create();
      uninterceptedAxiosInstance.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        responseType: 'arraybuffer', // Importante: Configurar para recibir como arraybuffer
      })
        .then((response) => {
          console.log("RESPONSE: -------------: ", response);
          const blob = new Blob([response.data], { type: 'application/pdf' });
          setPdfBlob(blob);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching PDF:', error);
          setIsLoading(false);
        });

      return () => {
        if (pdfBlob) {
          URL.revokeObjectURL(pdfBlob); // Limpiar la URL del blob
        }
      };
    }
  }, [isActive, url, token]);

  const handleDownload = () => {
    if (pdfBlob) {
      const downloadUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'document.pdf';
      link.click();
      URL.revokeObjectURL(downloadUrl); // Limpiar la URL después de la descarga
    }
  };

  if (isLoading) {
    return <div>Cargando documento...</div>;
  }

  if (!pdfBlob) {
    return null; // No hay documento cargado
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '8px' }}>
        {/* Botones y controles de zoom */}
        <ZoomOutButton />
        <ZoomPopover />
        <ZoomInButton />
        {
          isPdfDownload && 
          <Button color="primary" outline onClick={handleDownload} style={{ padding: '5px', marginLeft: '5px' }}>
            <Download size={16}/>
          </Button>
        }
      </div>
      <div style={{ flex: '1', overflow: 'hidden' }}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js">
          <Viewer
            fileUrl={URL.createObjectURL(pdfBlob)}
            plugins={[zoomPluginInstance]}
          />
        </Worker>
      </div>
    </div>
  );
}

export default PDFViewer;
